import { MemberProps } from "../typings/member";
import { HubConnection } from "@microsoft/signalr";
import { AppSettingsState } from './../typings/app';
//   --------------------  STATE  --------------------



export const SET_SYSTEM_HUB = "SET_SYSTEM_HUB";
export const SET_LOGIN_COMPLETE = "SET_LOGIN_COMPLETE";
export const SET_REGISTRATION_COMPLETE = "SET_REGISTRATION_COMPLETE";
export const SET_COMPLETION_QUESTIONS = "SET_COMPLETION_QUESTIONS";
export const SET_OPEN_MOOD_SELECT = "SET_OPEN_MOOD_SELECT";
export const RESET = "RESET";
//Action Types
interface SetSystemHubTypeAction {
    type: typeof SET_SYSTEM_HUB;
    hubConnection: HubConnection;
}

interface SetSystemLoginAction {
    type: typeof SET_LOGIN_COMPLETE;
    loginComplete: boolean;
}

interface SetSystemcompleteRegistrationAction {
    type: typeof SET_REGISTRATION_COMPLETE;
    completeRegistration: boolean;
}

interface SetAnswerCompletionQuestionsAction {
    type: typeof SET_COMPLETION_QUESTIONS;
    answerCompletionQuestions: boolean;
}

interface SetOpenMoodSelectAction {
    type: typeof SET_OPEN_MOOD_SELECT;
    openMoodSelect: boolean;
}

interface ResetAppData {
    type: typeof RESET;
}


//Action creators

export const setSystemHub = (hubConnection: HubConnection) => {
    return {
        type: SET_SYSTEM_HUB,
        hubConnection,
    };
}

export const setLoginComplete = (loginComplete: boolean) => {
    return {
        type: SET_LOGIN_COMPLETE,
        loginComplete,
    };
}

export const setRegistrationComplete = (completeRegistration: boolean) => {
    return {
        type: SET_REGISTRATION_COMPLETE,
        completeRegistration,
    };
}

export const setAnswerCompletionQuestions = (answerCompletionQuestions: boolean) => {
    return {
        type: SET_COMPLETION_QUESTIONS,
        answerCompletionQuestions,
    };
}

export const setOpenMoodSelectQuestions = (openMoodSelect: boolean) => {
    return {
        type: SET_OPEN_MOOD_SELECT,
        openMoodSelect,
    };
}

export const reset = () => {
    return {
        type: RESET,
    };
}

export type AppSettingsActionsTypes = SetSystemHubTypeAction | SetSystemLoginAction | ResetAppData
    | SetSystemcompleteRegistrationAction | SetAnswerCompletionQuestionsAction | SetOpenMoodSelectAction;


const initialState: AppSettingsState = {
    hubConnection: undefined,
    completeRegistration: false,
    loginComplete: false,
    answerCompletionQuestions: false,
    openMoodSelect: false
}

//Reducer


export default function reducer(state = initialState, action: AppSettingsActionsTypes): AppSettingsState {
    switch (action.type) {
        case SET_SYSTEM_HUB:
            return { ...state, hubConnection: action.hubConnection };
        case SET_LOGIN_COMPLETE:
            return { ...state, loginComplete: action.loginComplete };
        case SET_REGISTRATION_COMPLETE:
            return { ...state, completeRegistration: action.completeRegistration };
        case SET_COMPLETION_QUESTIONS:
            return { ...state, answerCompletionQuestions: action.answerCompletionQuestions };
        case SET_OPEN_MOOD_SELECT:
            return { ...state, openMoodSelect: action.openMoodSelect };
        case RESET: {
            return { ...initialState };
        }
        default:
            return state;
    }
}